import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import { getTemplatesApi } from '../apis/TemplateApi';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getTemplates() {
    return function (dispatch) {
        dispatch({
            type: types.GET_TEMPLATES_PENDING,
        });

        const handleResponse = (response) => {
            dispatch({
                type: types.GET_TEMPLATES_SUCCESS,
                payload: response.data.data,
            });
        };

        const handleErrorFn = (error) => {
            errorHandler(dispatch, error.response, types.GET_TEMPLATES_FAILED);
        };
        return getTemplatesApi()
            .then(handleResponse)
            .catch(handleErrorFn);
    };
}

export function getTemplate(state, id) {
    return function (dispatch) {
        dispatch({
            type: types.GET_TEMPLATE_PENDING,
        });
        const dataList = (data) => {
            return new Promise(((resolve) => {
                resolve(data);
            }));
        };
        const searchForTemplate = (templ) => { return templ.id === id; };

        const getTemplateFromList = (templates) => {
            const template = templates.find(searchForTemplate);
            if (typeof template !== 'undefined') {
                return dispatch({
                    type: types.GET_TEMPLATE_SUCCESS,
                    payload: template,
                });
            }
            return dispatch({
                type: types.GET_TEMPLATE_FAILED,
            });
        };

        const handleApiResponseAndGetTemplate = (response) => {
            dispatch({
                type: types.GET_TEMPLATES_SUCCESS,
                payload: response.data.data,
            });

            getTemplateFromList(response.data.data);
        };

        const handleApiErrorFn = (error) => {
            errorHandler(dispatch, error.response, types.GET_TEMPLATES_FAILED);
        };

        if (!state.data) {
            return getTemplatesApi()
                .then(handleApiResponseAndGetTemplate)
                .catch(handleApiErrorFn);
        }
        return dataList({ data: state })
            .then(handleApiResponseAndGetTemplate)
            .catch(handleApiErrorFn);
    };
}
